
import { useState, useEffect, Fragment } from "react";
import Config from "../../Config";

import InputDownloader from "../../helpers/InputDownloader";


import { PieChart, Pie, Cell, BarChart,
    Bar,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    Legend,
    ResponsiveContainer, } from 'recharts';

 


function Payment(props)
{

    const [refreshView, setRefreshView] = useState(props.userData.refreshView);
    const [tab, setTab] = useState(null);

    const [isRoot, setIsRoot] = useState(-1);



    const checkRoot = () => {
       
 
        props.mainView.setProgress(-2);

        var req = {
        
        };

        fetch( Config.url + '/rest_v1,check_root', {
            method: 'POST', 
            body: JSON.stringify(req), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

                    props.mainView.setProgress(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {
                        setIsRoot(res.result);              
                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
         });
                   

         return false;
    }




    const getData = () => {
       
 
        props.mainView.setProgress(-2);

        var req = {
        
        };

        fetch( Config.url + '/rest_v1,pay', {
            method: 'POST', 
            body: JSON.stringify(req), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

                    props.mainView.setProgress(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {
                        setTab(res);              
                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
         });
                   

         return false;
    }



   
        useEffect(() => {


            if(tab == undefined || tab == null)   return;
            if(tab.result == undefined) return;
            if( tab.result.faktury == undefined) return;


            for(var k=0; k<tab.result.faktury.length; k++)
            {                 
                var faktura = tab.result.faktury[k] ;

                if(faktura.gopay == null) continue;


                    const script = document.createElement('script')

                    script.src = faktura.gopay['script'];
                    script.async = true
                    // script.onload = () => {
        
                    //  }
        
                    document.body.appendChild(script)

                    if(k > 3) break;

            }


     

            return () => {
             // document.body.removeChild(script)
            }

        } )




        if(isRoot == -1)
            {
                setIsRoot(-2);
                checkRoot();
                return (
                    <div></div>
                );        
            }
    
        if(isRoot == -2)
        {
            return <div>...</div>
        }
        
    
        if(isRoot != 1)
        {
            return (
                <div className="view_content">
    
                    <br/>
                    <div className="calColor">Płatności / Umowa / Faktury</div>
    
                    <br/>
                    <div>Brak uprawnień do tej części strony. Wymagany "Administrator"</div>
                </div>
            )
         
        }

        




    if(tab == null)
    {
        setTab([]);
        getData(); 
        return (
            <div></div>
        );        
    }

    if(tab._sys_ == undefined) //no correct response..
    {
        return (
            <div></div>
        );   
    }


    if(refreshView != props.userData.refreshView)
    {         
        setRefreshView( props.userData.refreshView);
        getData();
    }
 



    const colors = ['#6aa44b', '#f25c37' ];
    const colors2 = ['#69b6bd', '#5482ac' ];

   
    var fData = new Array();
    fData = [
        {  nazwa: "Rozliczone",  wartosc: 12 },
        {  nazwa: "Nierozliczone", wartosc: 88 },
    ];

   

    



    return (
        <div className="view_content">
 

            <div className="bg_center">   
                    <table className="table_info">
                        <tbody>

                            <tr>
                                <td><b>Aktualny pakiet / umowa: </b> </td>
                                <td> {tab.result.nazwa} </td>
                                <td>&nbsp;</td>
                            </tr>

                            <tr>
                                <td><b>Aktualny do / czas obowiązywania: </b> </td>
                                <td> {tab.result.do_dnia} </td>
                                <td>&nbsp;</td>
                            </tr>

                            <tr>
                                <td><b>Maksymalna ilość dzieci łącznie dla wszystkich placówek: </b> </td>
                                <td className="gobold"> * {tab.result.max_dzieci} </td>
                                <td>&nbsp;</td>
                            </tr>

                            <tr>
                                <td colSpan={3}>
                                    *Jeżeli chcesz zmienić limity dotyczące ilości dzieci w ramach pakietu (umowy) skontaktuj się z działem obsługi klienta<br/>
                                    pod numerem <b className="link_color">800 808 868</b> lub za pomocą poczty elektronicznej: <b className="link_color">kontakt@elizak.edu.pl </b>
                                </td>
                            </tr>

                            <tr>                               
                                <td colSpan={2} >  
                                    <br/>
                                    <table>                                    
                                        {
                                            tab.result.st.map( (info, ixInfo) => {
                                                return <tr key={ixInfo}>
                                                        <td className="calColor">{info.nazwa}</td>
                                                        <td  className="">aktywnych dzieci: <b>{info.ilosc}</b>   </td>
                                                        <td  className="">**danych multimedialnych: <b>{info.ilosc_danych_mb} MB</b> </td>
                                                </tr>
                                            } ) 
                                        }
                                    </table>
                                </td>
                                <td className="gocenter">
                                    

                               


                                </td>
                            </tr>

                            
                            <tr>
                                <td colSpan={2}>
                                     Limit danych mulitimedialnych (filmy, zdjęcia, pliki użytkowników) to obecnie: <b className="link_color">{ tab.result.dane_max_mb} MB </b> Po przekroczeniu limitu
                                     najstarsze dane zostają usunięte zaczynając od tych najwcześniej dodanych. 
                                </td>
                            </tr>

                        </tbody>    
                    </table>  
                 
            </div>


            <div className="calColor">Wystawione faktury</div>
            <br/>

            <div className="bg_center">  
                
                     <table className="table">


                           <thead>
                                <tr className="header">
                                    <td className="td_left">LP</td>                           
                                    <td>Numer</td>  
                                    <td>Data wystawienia</td>  
                                    <td>Termin płatności</td>  
                                    <td>Do zapłaty</td>  
                                    <td className="td_right">Kwota zapłacona</td>  
                                    <td className="td_option"> </td>                                                                 
                                    <td className="td_option"> </td>                                                                 
                                </tr>
                            </thead>

                            <tbody>

                                {
                                    tab.result.faktury.map( (item, ix) => {

                                        var rowStyle = " row ";
                                    if(ix % 2 == 0 )rowStyle = " row2 ";

                                            return (
                                                <tr className={rowStyle}>
                                                    <td className="gocenter">{ix+1}</td>                           
                                                    <td className="gocenter">{item.numer}</td>  
                                                    <td className="gocenter">{item.data_wystawienia}</td>  
                                                    <td className="gocenter">{item.termin_platnosci}</td>  
                                                    <td className="goright">{item.do_zaplaty}</td>  
                                                    <td className="goright">{item.kwota_rozliczenia}</td>                                                      
                                                    <td className="td_btn_option"> <InputDownloader  mainView={props.mainView} userData={props.userData} fileType="pdf" link={  Config.url + '/rest_v1,pay,crypt,'+item.crypt } title="pobierz" className="link_normal" /> </td>                                                                 
                                                    <td className="td_btn_option">
                                                        { 
                                                            item.gopay != null &&
                                                            <Fragment>
                                                                <div dangerouslySetInnerHTML={{ __html: item.gopay["div"] }} /> 
                                                                <script type="text/javascript" src={item.gopay["script"] } ></script>                                                                                                                          
                                                            </Fragment>
                                                        }
                                                                                                               
                                                    </td>  
                                                </tr>
                                            )
                                    } )
                                }                       
 
                            </tbody>    
                        </table>  
                 

            </div>



        </div>
    )
}


export default Payment;